export const NEUTRAL_NAME = "Empfehlungs-Kompass";
export const DEFAULT_CLAIM = "Weiterempfehlen aus Überzeugung";
export const NEUTRAL_BRAND = { name: NEUTRAL_NAME, claim: DEFAULT_CLAIM };

export function Logo({ light = false, className = "", name = "Prämio", claim = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <span className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-lg bg-white ring-1 ring-black/5">
        <img src="/logo-mark.png" alt={`${name} Logo`} className="h-8 w-8 object-contain" />
      </span>
      <span className="flex flex-col">
        <span
          className={`font-display text-lg leading-none tracking-tight ${light ? "text-[#F8F9FA]" : "text-[#0A1128]"}`}
          data-testid="app-logo-name"
        >
          {name}
        </span>
        {claim && (
          <span className={`mt-1 text-[10px] leading-none tracking-wide ${light ? "text-white/55" : "text-[#8a6d2f]"}`}>
            {claim}
          </span>
        )}
      </span>
    </div>
  );
}
